
import { defineComponent } from 'vue'
import { EventBus } from '@/event-bus'
import AppHeader from '@/components/AppHeader.vue'
import Spinner from '@/components/Spinner.vue'
export default defineComponent({
	name: 'App',

	components: {
		AppHeader,
		Spinner
	},

	data(): { meetJoined: boolean } {
		return {
			meetJoined: false
		}
	},

	computed: {
		isMobile(): boolean {
			return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
		}
	},
	mounted(): void {
		EventBus.$on('meetJoined', (joined: boolean) => {
			this.meetJoined = joined
		})
	},

	beforeDestroy(): void {
		EventBus.$off('meetJoined')
	}
})
